import is from '@sindresorhus/is';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';

export type ModalContextType = {
    readonly closeFeedbackModal: () => void;
    readonly isOpen: boolean;
    readonly openFeedbackModal: () => void;
};

const ModalContext = createContext<ModalContextType | null>(null);

export const useSkillFeedbackModalContext = (): ModalContextType => {
    const context = useContext(ModalContext);

    if (is.nullOrUndefined(context)) {
        throw new Error('useModalContext must be used within a ModalContextProvider');
    }

    return context;
};

export const SkillFeedbackModalContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openFeedbackModal = (): void => setIsOpen(true);
    const closeFeedbackModal = (): void => setIsOpen(false);

    return (
        <ModalContext.Provider value={{ closeFeedbackModal, isOpen, openFeedbackModal }}>
            {children}
        </ModalContext.Provider>
    );
};
